import * as React from "react";
import { Text, View, Image, StyleSheet, TextInput, Platform } from "react-native";

import { Amplify, Auth } from "aws-amplify";
import getEnvVars from "../../enviroment";
import { useNavigation, useRoute } from "@react-navigation/native";
import { useDispatch } from "react-redux";
import GlobalStyles from "../../components/GlobalStyles";
import { TouchableOpacity } from "react-native-gesture-handler";
import { AntDesign } from "@expo/vector-icons";
import { Layout, Select, SelectItem } from "@ui-kitten/components";
import IntlPhoneInput from "react-native-intl-phone-input";
import PhoneInput from "react-native-phone-number-input";
const awsConfig = getEnvVars().awsConfig;

Amplify.configure(awsConfig);
export default function ReferredSignUpScreen() {
  let platform = Platform.OS;
  const dispatch = useDispatch();

  const route = useRoute();

  let initialRefCode = '';
  if (route.params != undefined) initialRefCode = route.params.referrer;

  const [username, onChangeUserText] = React.useState("");
  const [password, onChangePassText] = React.useState("");
  const [email, onChangeEmailText] = React.useState("");
  const [phone, onChangePhoneText] = React.useState("");
  const [value, setValue] = React.useState("");
  const [valueCode, setValueCode] = React.useState("61");
  const [givenName, onChangeGivenNameText] = React.useState("");
  const [familyName, onChangeFamilyNameText] = React.useState("");
  const [authCode, onChangeAuthCodeText] = React.useState("");

  const [errorMsg, onErrorMsg] = React.useState("");

  const [referralCode, onChangeReferralCode] = React.useState(initialRefCode);

  const [showHidePassword, onChangePasswordShow] = React.useState(true);
  const SIGNUPMODE_EMAIL = 0;
  const SIGNUPMODE_PHONE = 1;
  const [signupMode, setSignupMode] = React.useState(SIGNUPMODE_EMAIL); // FALSE = email, TRUE = phone

  const SIGNUPSTAGE_FORM = 0;
  const SIGNUPSTAGE_CODE = 1;
  const SIGNUPSTAGE_FINAL = 2;
  const [signupStage, setStage] = React.useState(SIGNUPSTAGE_FORM);

  const navigation = useNavigation();

  const [selectedLoginIndex, setSelectedLoginIndex] = React.useState(0);
  const displayLoginEnum = [
    null,
    ' Log in using my Email',
    ' Log in using my Phone'
  ];

  function setSignupModeTransfer(index) {
    switch(index.row) {
      case 1:
        // phone case
        setSignupMode(SIGNUPMODE_PHONE);
        setSelectedLoginIndex(index);
        break;
      case 2:
        setSignupMode(SIGNUPMODE_EMAIL);
        setSelectedLoginIndex(index);
        break;
      case 0:
      default:
        // default - in this case fallback to email mode
        setSignupMode(SIGNUPMODE_EMAIL);
        setSelectedLoginIndex(index);
    }
  }

  const trySignUp = async (mode, password, email, givenN, familyN, phone, refererId) => {
    try {
      var tempPhone = phone.substring(4);
      var un = "";
      if (mode === SIGNUPMODE_PHONE) {
        if (tempPhone !== "") {
          un = phone;
        } else {
          onErrorMsg("Phone Required");
          return;
        }
        
      } else if (mode === SIGNUPMODE_EMAIL) {
        if (email !== "") {
          un = email;
        } else {
          onErrorMsg("Email Required");
          return;
        }
      }

      var attri = {
        given_name: givenN,
        family_name: familyN,
        'custom:refererId': refererId
      };
      if (mode === SIGNUPMODE_PHONE) {
        attri.phone_number = un;
        attri.email = "";
      } else if (mode === SIGNUPMODE_EMAIL) {
        attri.phone_number = "";
        attri.email = un;
      }
      // console.log(un);
      const res = await Auth.signUp({
        username: un,
        password: password,
        attributes: attri,
      });
      setStage(SIGNUPSTAGE_CODE);
    } catch (error) {
      onErrorMsg(error.message);
    }
  };

  const confirmSignUp = async (username, authCode, formMode) => {
    var formDeref = "e";
    if (formMode === SIGNUPMODE_PHONE) formDeref = "p";
    try {
      await Auth.confirmSignUp(username, authCode);
      // console.log("user successfully signed up");
      navigation.navigate("Login", { formMode: formDeref });
    } catch (error) {
      onErrorMsg(error.message);
    }
  };

  return (
    <View style={GlobalStyles.containerMB}>
      {signupStage === SIGNUPSTAGE_FORM ?
        <View style={styles.BodyContainer}>
          <View style={styles.headerContainer} >
            <TouchableOpacity
              style={styles.headerBackButtonStyle}
              onPress={() => navigation.goBack()}
            >
            </TouchableOpacity>
            <View>
              <Text style={styles.HTextStyle}>REGISTER</Text>
            </View>
            <TouchableOpacity
              style={styles.headerNextButtonContainer}
              onPress={() => {
                // phone field fixing
                var myphone = "";
                var un = "";
                if (platform === "web") {
                  un = value;
                  if (un.charAt(0) == '0') un = un.substring(1);
                  un = "+" + valueCode + un;
                } else {
                  un = phone.unmaskedPhoneNumber;
                  if (un != undefined) {
                    if (un.charAt(0) == "0") un = un.substring(1);
                    un = phone.dialCode.concat(un);  
                  } else {
                    un = "";
                  }
                }
                var myphone = un;
              //
                trySignUp(signupMode, password, email, givenName, familyName, myphone, referralCode);
              }}
            >
              <Text style={styles.topRightHeaderText}>NEXT</Text>
              <View style={styles.textUnderline}></View>
            </TouchableOpacity>
          </View>
          <View style={styles.infoBox}>
          <Text style={styles.TextStyleHeader}>Create new account</Text>
            {/* <Text>REFERRAL CODE: {referralCode}</Text> */}
            <View style={styles.inputContainer}>
              <TextInput
                style={styles.textInput}
                placeholder="First Name"
                placeholderTextColor="#adb4bc"
                returnKeyType="next"
                autoCapitalize="none"
                autoCorrect={false}
                secureTextEntry={false}
                value={givenName}
                onChangeText={(text) => onChangeGivenNameText(text)}
              />
            </View>
            {/* second name section */}
            <View style={styles.inputContainer}>
              <TextInput
                style={styles.textInput}
                placeholder="Last Name"
                placeholderTextColor="#adb4bc"
                returnKeyType="next"
                autoCapitalize="none"
                autoCorrect={false}
                secureTextEntry={false}
                value={familyName}
                onChangeText={(text) => onChangeFamilyNameText(text)}
              />
            </View>
            {/* <View style={styles.toggleContainer}>
              <Text style={styles.toggletextLabel} >Choose Login Mode</Text>
              <View>
                <TouchableOpacity
                  activeOpacity={0.5}
                  onPress={() => {
                    setSignupMode(SIGNUPMODE_PHONE)
                  }}
                  style={styles.toggleButton}
                >
                  <Text style={styles.toggleButtonText}>PHONE</Text>
                </TouchableOpacity></View><View>
                <TouchableOpacity
                  activeOpacity={0.5}
                  onPress={() => {
                    setSignupMode(SIGNUPMODE_EMAIL)
                  }}
                  style={styles.toggleButton}
                >
                  <Text style={styles.toggleButtonText} >EMAIL</Text>
                </TouchableOpacity>
              </View>
            </View> */}
            <View style={styles.toggleContainer}>
              <Layout style={styles.dropDowncontainer}>
                <Select
                  size='large'
                  selectedIndex={selectedLoginIndex}
                  style={styles.selectDropDownStyle}
                  placeholder='Log in using my Email'
                  onSelect={(index) => setSignupModeTransfer(index)}
                  value={displayLoginEnum[selectedLoginIndex]}
                >
                  <SelectItem title='Log in using my Email' value='0' />
                  <SelectItem title='Log in using my Phone' value='1' />
                </Select>
              </Layout>
            </View>
            {signupMode === SIGNUPMODE_EMAIL ?
              <View style={styles.inputContainer}>
                <TextInput
                  style={styles.textInput}
                  placeholder="Email"
                  placeholderTextColor="#adb4bc"
                  keyboardType={"email-address"}
                  returnKeyType="next"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={false}
                  value={email}
                  onChangeText={(text) => onChangeEmailText(text)}
                  dialCodeTextStyle={styles.textInput}
                />
              </View>
              :
              <View style={styles.inputContainer}>
                {/* <TextInput
                  style={styles.textInput}
                  placeholder="Phone"
                  placeholderTextColor="#adb4bc"
                  keyboardType={"email-address"}
                  returnKeyType="next"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={false}
                  value={phone}
                  onChangeText={(text) => onChangePhoneText(text)}
                  dialCodeTextStyle={styles.textInput}
                /> */}
                  <View style={styles.textInputNoUnderline}>
                {platform === "web" ? (
                      <View style={styles.flexStyle}>
                        <Text style={styles.formLabelStyle}>Phone</Text>
                        <PhoneInput
                          defaultCode={"AU"}
                          value={phone}
                          placeholder=" "
                          onChangeText={(text) => setValue(text)}
                          onChangeCountry={(text) => setValueCode(text.callingCode[0])}
                          autoFocus={true}
                          containerStyle={{
                            width: 50,
                            height: 35,
                          }}
                          textContainerStyle={{
                            backgroundColor: "transparent",
                            paddingLeft: 0,
                          }}
                          codeTextStyle={{
                            fontSize: 16,
                            fontFamily: "montserrat-regular",
                            color: "#2f7185",
                          }}
                          layout={"second"}
                          textInputStyle={{
                            ...Platform.select({
                              web: {
                                outlineStyle: 'none'
                              }
                            }), 
                            fontSize: 16,
                            fontFamily: "montserrat-regular",
                            height: 40,
                            width: 180,
                          }}
                          flagButtonStyle={{
                            width: 60,
                          }}
                        />
                      </View>
                    ) : (
                        <View style={styles.flexStyle}>
                          <Text style={styles.formLabelStyle}>Phone</Text>
                          <IntlPhoneInput
                            onChangeText={onChangePhoneText}
                            ref={(ref) => (phoneInput = ref)}
                            customModal={renderCustomModal}
                            defaultCountry="AU"
                            placeholder=""
                            containerStyle={{
                              flex: 3,
                            }}
                            flagStyle={{ display: "none" }}
                            // filterInputStyle={styles.textInput}
                            dialCodeTextStyle={{
                              fontSize: 16,
                              fontFamily: "montserrat-regular",
                              color: "#2f7185",
                            }}
                            phoneInputStyle={{
                              fontSize: 16,
                              fontFamily: "montserrat-regular",
                            }}
                            modalCountryItemCountryNameStyle={{
                              color: "black",
                              // flagStyle: { display: "none" },
                            }}
                          />
                        </View>
                      )}
              </View>
              </View>
            }
            <View style={styles.PasswordinputContainer}>
              <View style={styles.Passwordinput}>
                <TextInput
                  style={styles.textInputPassword}
                  placeholder="Create Password"
                  placeholderTextColor="#adb4bc"
                  returnKeyType="next"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={showHidePassword}
                  value={password}
                  onChangeText={(text) => onChangePassText(text)}
                />
              </View>
              <View style={styles.PasswordToggle}>
                <TouchableOpacity
                  style={styles.iconContainer}
                  onPress={() =>
                    showHidePassword
                      ? onChangePasswordShow(false)
                      : onChangePasswordShow(true)
                  }
                >
                  {showHidePassword ? (
                    <AntDesign color="#aaaaaa" name="eyeo" size={20} />
                  ) : (
                    <AntDesign color="#aaaaaa" name="eye" size={20} />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <Text style={styles.TextStylePasswordBold}>
              At least 8 characters.
            </Text>
            <Text style={styles.TextStylePassword}>
              (With 1 letter and 1 number.)
            </Text>
            <Text style={styles.feildLabel}>Referral Code</Text>
            <View style={styles.inputContainer}>
              <TextInput
                style={styles.textInput}
                placeholder="Add Referral Code (optional)"
                placeholderTextColor="#adb4bc"
                keyboardType={"default"}
                returnKeyType="next"
                autoCapitalize="none"
                autoCorrect={false}
                secureTextEntry={false}
                value={referralCode}
                onChangeText={(text) => onChangeReferralCode(text)}
                dialCodeTextStyle={[styles.textInput, { borderBottomWidth: 0 }]}
              />
            </View>
          </View>
          <View style={styles.submitButtonContainer}>
            <TouchableOpacity
              style={styles.SubmitButtonStyle}
              activeOpacity={0.5}
              onPress={() => {
                // phone field fixing
                var myphone = "";
                var un = "";
                if (platform === "web") {
                  un = value;
                  if (un.charAt(0) == '0') un = un.substring(1);
                  un = "+" + valueCode + un;
                } else {
                  un = phone.unmaskedPhoneNumber;
                  if (un != undefined) {
                    if (un.charAt(0) == "0") un = un.substring(1);
                    un = phone.dialCode.concat(un);  
                  } else {
                    un = "";
                  }
                }
                var myphone = un;
              //
                trySignUp(signupMode, password, email, givenName, familyName, myphone, referralCode);
              }}
            >
              <Text style={styles.submitButtonText}>NEXT</Text>
            </TouchableOpacity>
          </View>
          <View>
            <Text style={styles.TextStyleError}>{errorMsg}</Text>
          </View>
        </View> : <></>}
      {signupStage === SIGNUPSTAGE_CODE ?
        <View style={styles.BodyContainer}>
          <View style={styles.verificationBox}>
            <Text style={styles.TextStyleVerificationHeader}>
              Verification Code
            </Text>
            <Text style={styles.textStyleBodyCenter}>
              Check your email/phone for the verification code.
            </Text>
            <View style={styles.inputContainer}>
              <TextInput
                style={styles.textInputConf}
                placeholder="Enter code"
                placeholderTextColor="#adb4bc"
                keyboardType={"numeric"}
                returnKeyType="done"
                autoCapitalize="none"
                autoCorrect={false}
                secureTextEntry={false}
                value={authCode}
                onChangeText={(text) => onChangeAuthCodeText(text)}
              />
            </View>
            <TouchableOpacity
              style={styles.SubmitResndButtonStyle}
              onPress={async () => { }}
            >
              <Text style={styles.TextStyleResend}>RESEND CODE</Text>
            </TouchableOpacity>
          </View>
          <View style={styles.submitButtonContainer}>
            <TouchableOpacity
              style={styles.SubmitButtonStyle}
              onPress={() => { 
                var un = "";
                if (
                  signupMode === SIGNUPMODE_PHONE //&&
                  //phone.unmaskedPhoneNumber !== undefined
                ) {
                  if (platform === "web") {
                    un = value;
                    if (un.charAt(0) == '0') un = un.substring(1);
                    un = "+" + valueCode + un;
                  } else {
                    un = phone.unmaskedPhoneNumber;
                    if (un.charAt(0) == "0") un = un.substring(1);
                    un = phone.dialCode.concat(un);
                  }
                } else if (signupMode === SIGNUPMODE_EMAIL && email !== "") un = email;
                else {
                  onErrorMsg("Phone or Email Required");
                  return;
                }
                // onErrorMsg(un);
                confirmSignUp(un, authCode, signupMode);
               }}
            >
              <Text style={styles.submitButtonText}>CONFIRM</Text>
            </TouchableOpacity>
          </View>
        </View> : <></>}
      {signupStage === SIGNUPSTAGE_FINAL ?
        <View style={styles.BodyContainer}>
          <View style={styles.verificationBox}>
            <Text>Thank you for signing up for Aura Rewards.</Text>
            <Text>Please login with your new account to finalize signup.</Text>
            <Text>Link to Sign In Page (NYI)</Text>
          </View>
        </View> : <></>}
    </View>
  );
}

const styles = StyleSheet.create({
  inputContainer: {
    paddingTop: 15,
  },
  TextStyleError: {
    color: "#FFFFFF",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 16,
    paddingTop: 20,
  },
  
  textInputNoUnderline: {
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
    // flex: 1,
    // flexDirection: "row"
  },
  
  TextStyleHeader: {
    color: "black",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingBottom: 5,
    paddingTop:30,
    //paddingLeft: 30,
    //paddingRight: 30,
  },
  
  feildLabel: {
    color: "black",
    textAlign: "left",
    fontFamily: "montserrat-medium",
    fontSize: 12,
    width: "100%",
    paddingBottom: 0,
    paddingTop:20,
    //paddingLeft: 30,
    //paddingRight: 30,
  },
  HTextStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },
  headerNextButtonContainer: {
    marginTop: 0,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft:50,
   // width: 75,
  },
  TextStylePasswordBold: {
    color: "#757575",
    textAlign: "center",
    fontFamily: "montserrat-semibold",
    fontSize: 10,
    paddingTop: 16,
  },
  TextStylePassword: {
    color: "#757575",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    paddingTop: 3,
  },
  textInput: {
    outlineStyle: 'none',
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
  },
  textInputPassword: {
    outlineStyle: 'none',
    borderColor: "#CCCCCC",
    borderBottomWidth: 0,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
  },
  BodyContainer: {
    paddingTop: 45,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  infoBox: {
    height: 500,
    width: 350,
    backgroundColor: "#ffffff",
    borderRadius: 15,
    //marginBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingTop: 5,
    alignSelf: "center",
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
  },
  topRightHeaderText: {
    color: "#ffffff",
    textAlign: "right",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },
  textUnderline: {
    width: "90%",
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "flex-end",
    marginTop: 10,
    marginBottom: 0,
  },
  headerBackButtonStyle: {
    marginTop: 0,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },
  submitButtonContainer: {
    flexDirection: "row",
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 20,
    paddingBottom: 20,
    alignSelf: "center",
  },


  SubmitButtonStyle: {
    marginTop: 0,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#FFC40C",
    borderRadius: 50,
    justifyContent: "center",
    width: 350,
    height: 60,
    alignSelf: "center",
  },

  submitButtonText: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },

  toggleContainer: {
    flexDirection: "row",
    marginTop: 10,
    alignItems: "center",
  },
  dropDowncontainer: {
    width: "100%",
  },
  selectDropDownStyle: {
    flex: 1,
    height: 200,
  },
  // toggleButtonContainer: {
  //   flexDirection: "row",
  //   justifyContent: "space-between",
  //   marginTop: 10
  // },
  toggletextLabel: {
    color: "#000000",
    fontFamily: "montserrat-medium",
    fontSize: 13,
  },
  // toggleButton: {
  //   flex: 1,
  //   paddingTop: 10,
  //   paddingBottom: 10,
  //   paddingLeft: 15,
  //   paddingRight: 15,
  //   borderRadius: 50,
  //   backgroundColor: "#4CC9EE",
  //   height: 30,
  // },
  // toggleButtonText: {
  //   color: "#000000",
  //   textAlign: "center",
  //   fontFamily: "montserrat-medium",
  //   fontSize: 10,
  // },
  PasswordinputContainer: {
    paddingTop: 15,
    flexDirection: "row",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
  },
  iconContainer: {
    //paddingLeft: 0,
    //paddingRight: 30,
    paddingTop: 10,
    //width: 50,
  },

  Passwordinput: {
    flex: 7,
  },

  flexStyle: {
    flex: 1,
    flexDirection: "row",
  },
  formLabelStyle: {
    color: "#aaaaaa",
    textAlign: "center",
    textAlignVertical: "center",
    fontFamily: "montserrat-regular",
    fontSize: 15,
    paddingRight: 20,
    paddingTop: 8,
    borderColor: "#CCCCCC",
    // borderBottomWidth: 1,
  },
  PasswordToggle: {
    flex: 1,
    paddingLeft: 45,
    paddingRight: 0,
    //paddingTop: 10,
  },
  verificationBox: {
    width: 350,
    backgroundColor: "#ffffff",
    borderRadius: 15,
    marginBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingTop: 20,
    alignSelf: "center",
  },
  TextStyleResend: {
    padding: 5,
    fontSize: 12,
    color: "#337599",
    fontWeight: "bold",
    textAlign: "center",
  },
  SubmitButtonStyleConfirm: {
    marginTop: 30,
    marginLeft: 120,
    marginRight: 120,
    paddingTop: 22,
    paddingBottom: 25,
    backgroundColor: "#337599",
    borderRadius: 50,
    justifyContent: "center",
    height: 60,
  },
  buttonTextStyle: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },
  TextStyleVerificationHeader: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    marginBottom: 20,
  },
  textStyleBodyCenter: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    marginLeft: -15,
  },
  textInputConf: {
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 30,
    paddingRight: 20,
    textAlign: "center",
    fontFamily: "montserrat-regular",
  },
  SubmitResndButtonStyle: {
    marginTop: 0,
    marginLeft: 50,
    marginRight: 50,
    borderRadius: 50,
    justifyContent: "center",
    height: 30,
  },
});
